import makeStyles from '@mui/styles/makeStyles';

const useMonthlyInverterGraphStyles = makeStyles({
  root: {}
});

export default useMonthlyInverterGraphStyles;
